var _filter, _filter2, _rect, _pattern, _rect2, _text, _text2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg02WebsocketScalability(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 800 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "userGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#3b82f6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#6366f1"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "serverOverload",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ef4444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#dc2626"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "shadow2",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 8,
    floodOpacity: 0.2
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 500,
    fill: "#0f172a"
  })), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "grid2",
    width: 30,
    height: 30,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 30 0 L 0 0 0 30",
    fill: "none",
    stroke: "#1e293b",
    strokeWidth: 0.5
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 500,
    fill: "url(#grid2)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 40,
    textAnchor: "middle",
    fill: "#f8fafc",
    fontFamily: "system-ui, sans-serif",
    fontSize: 24,
    fontWeight: "bold"
  }, "\n    WebSocket Scalability Problem\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 65,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14
  }, "\n    Server becomes bottleneck with many users\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400, 250)",
    filter: "url(#shadow2)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 60,
    fill: "url(#serverOverload)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "60;65;60",
    dur: "0.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    r: 60,
    fill: "none",
    stroke: "#fca5a5",
    strokeWidth: 3,
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "60;80;60",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.5;0;0.5",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: "bold"
  }, "\n      SERVER\n    "), /*#__PURE__*/React.createElement("text", {
    y: 22,
    textAnchor: "middle",
    fill: "#fecaca",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11
  }, "\n      OVERLOADED!\n    "))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400, 170)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,-20 18,15 -18,15",
    fill: "#fbbf24",
    stroke: "#f59e0b",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.6;1",
    dur: "0.8s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    y: 8,
    textAnchor: "middle",
    fill: "#1c1917",
    fontFamily: "system-ui, sans-serif",
    fontSize: 18,
    fontWeight: "bold"
  }, "!"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150, 150)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 30,
    fill: "url(#userGrad)",
    filter: "url(#shadow2)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -5,
    r: 8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -10 12 Q 0 5 10 12",
    stroke: "#fff",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 0,
    x2: 310,
    y2: 70,
    stroke: "#3b82f6",
    strokeWidth: 2,
    strokeDasharray: "5,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "0.8s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(250, 100)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 30,
    fill: "url(#userGrad)",
    filter: "url(#shadow2)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -5,
    r: 8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -10 12 Q 0 5 10 12",
    stroke: "#fff",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 30,
    x2: 120,
    y2: 120,
    stroke: "#3b82f6",
    strokeWidth: 2,
    strokeDasharray: "5,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "0.8s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(550, 100)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 30,
    fill: "url(#userGrad)",
    filter: "url(#shadow2)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -5,
    r: 8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -10 12 Q 0 5 10 12",
    stroke: "#fff",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -30,
    y1: 30,
    x2: -120,
    y2: 120,
    stroke: "#3b82f6",
    strokeWidth: 2,
    strokeDasharray: "5,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "0.8s",
    repeatCount: "indefinite"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(650, 150)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 30,
    fill: "url(#userGrad)",
    filter: "url(#shadow2)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -5,
    r: 8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -10 12 Q 0 5 10 12",
    stroke: "#fff",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -30,
    y1: 0,
    x2: -190,
    y2: 70,
    stroke: "#3b82f6",
    strokeWidth: 2,
    strokeDasharray: "5,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "0.8s",
    repeatCount: "indefinite"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(650, 350)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 30,
    fill: "url(#userGrad)",
    filter: "url(#shadow2)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -5,
    r: 8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -10 12 Q 0 5 10 12",
    stroke: "#fff",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -30,
    y1: 0,
    x2: -190,
    y2: -70,
    stroke: "#3b82f6",
    strokeWidth: 2,
    strokeDasharray: "5,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "0.8s",
    repeatCount: "indefinite"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(550, 400)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 30,
    fill: "url(#userGrad)",
    filter: "url(#shadow2)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -5,
    r: 8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -10 12 Q 0 5 10 12",
    stroke: "#fff",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -30,
    y1: -30,
    x2: -120,
    y2: -120,
    stroke: "#3b82f6",
    strokeWidth: 2,
    strokeDasharray: "5,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "0.8s",
    repeatCount: "indefinite"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(250, 400)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 30,
    fill: "url(#userGrad)",
    filter: "url(#shadow2)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -5,
    r: 8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -10 12 Q 0 5 10 12",
    stroke: "#fff",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: -30,
    x2: 120,
    y2: -120,
    stroke: "#3b82f6",
    strokeWidth: 2,
    strokeDasharray: "5,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "0.8s",
    repeatCount: "indefinite"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150, 350)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 30,
    fill: "url(#userGrad)",
    filter: "url(#shadow2)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -5,
    r: 8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -10 12 Q 0 5 10 12",
    stroke: "#fff",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 0,
    x2: 190,
    y2: -70,
    stroke: "#3b82f6",
    strokeWidth: 2,
    strokeDasharray: "5,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "0.8s",
    repeatCount: "indefinite"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 440)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 700,
    height: 50,
    rx: 10,
    fill: "#1e293b"
  }), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 32,
    fill: "#f8fafc",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#ef4444",
    fontWeight: "bold"
  }, "Problem:"), " Each connection requires server resources \u2022 More users = More load \u2022 Single point of failure\n    "))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg02WebsocketScalability);
export default __webpack_public_path__ + "static/media/02-websocket-scalability.91035e2a8ec66ee2841c1d5bdfbea955.svg";
export { ForwardRef as ReactComponent };